<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div>
<!--           <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">Profile

            </h4>
          </div> -->
          <div style="box-shadow: none !important;" class="card ">

            <div class="card-body ">

              <div class="tab-content tab-space">
                <div class="tab-pane active" id="link1">
                  <form #userForm="ngForm" (ngSubmit)="onSubmit()">

                    <div class="row bloque mi">
                      <div class='col-md-12'>

                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group">
  <!--                             <label class="bmd-label-floating">Company Name</label>
                              <select name="companyLinked" #companyLinked="ngModel" [(ngModel)]="companySelected"
                                class="form-control fctrl" disabled>
                                <option *ngFor="let company of companies" [value]="company.id">
                                  {{ company.name }}
                                </option>
                              </select> -->
                              <label class="bmd-label-floating">Company Name</label>
                              <input readonly type="text" class="form-control fctrl" name="companyLinked" #companyLinked="ngModel" [(ngModel)]="this.user.companyLinked.name"
                              disabled>
                            </div>

                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">Title</label>
                              <input readonly type="text" class="form-control fctrl" name="ocupation" #ocupation="ngModel"
                                [(ngModel)]="user.ocupation">
                            </div>

                          </div>
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">First Name</label>
                              <input readonly type="text" class="form-control fctrl" name="name" #name="ngModel"
                                [(ngModel)]="user.name" required>
                              <span *ngIf="!name.valid && name.touched">
                                ¡Name not valid!
                              </span>
                            </div>

                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="bmd-label-floating">Last Name</label>
                              <input readonly type="text" class="form-control fctrl" name="surname" #surname="ngModel"
                                [(ngModel)]="user.surname" required>
                            </div>

                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">

                            <div class="form-group">
                              <label class="bmd-label-floating">email</label>
                              <input readonly type="email" class="form-control fctrl" name="email" #email="ngModel"
                                [(ngModel)]="user.email">
                            </div>

                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="bmd-label-floating">Gender</label>
                              <select name="gender" #gender="ngModel" [(ngModel)]="user.gender"
                                class="form-control fctrl" disabled>
                                <option *ngFor="let sexo of sexos" [value]="sexo.value">
                                  {{ sexo.viewValue }}
                                </option>
                              </select>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="row bloque mi">
                      <div class='col-md-12'>

                        <h3 class='card-title title'><b>Address information:</b></h3>
                        <hr>

                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group">
                              <label class="bmd-label-floating">Address Line #</label>
                              <input readonly type="text" class="form-control fctrl" name="address" #address="ngModel"
                                [(ngModel)]="user.address">
                            </div>

                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group">
                              <label class="bmd-label-floating">Address Line 2 #</label>
                              <input readonly type="text" class="form-control fctrl" name="address2" #address2="ngModel"
                                [(ngModel)]="user.address2">
                            </div>

                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">City</label>
                              <input readonly type="text" class="form-control fctrl" name="city" #city="ngModel"
                                [(ngModel)]="user.city">
                            </div>

                          </div>
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">State</label>
                              <input readonly type="text" class="form-control fctrl" name="colonia" #colonia="ngModel"
                                [(ngModel)]="user.colonia">
                            </div>

                          </div>
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">Zip Code</label>
                              <input readonly type="text" class="form-control fctrl" name="zipCode" #zipCode="ngModel"
                                [(ngModel)]="user.zipCode">
                            </div>

                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">Country</label>
                              <input readonly type="text" class="form-control fctrl" name="country" #country="ngModel"
                                [(ngModel)]="user.country">
                            </div>

                          </div>
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">Work Phone</label>
                              <input readonly type="text" class="form-control fctrl" name="phone" #phone="ngModel"
                                [(ngModel)]="user.phone">
                            </div>

                          </div>
                          <div class="col-md-4">

                            <div class="form-group">
                              <label class="bmd-label-floating">Mobile Phone</label>
                              <input readonly type="text" class="form-control fctrl" name="mobilePhone" #mobilePhone="ngModel"
                                [(ngModel)]="user.mobilePhone">
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                    
                    <div class="row bloque mi">
                      <div class='col-md-12'>

                        <h3 class='card-title title'><b>Settings:</b></h3>
                        <hr>

                        <div class="row">
                          <div *ngIf="user.role === 'VENDOR' || user.role === 'customer' || user.role === 'CUSTOMER'" class="col-md-6">

                            <div class="form-group">
                              <label class="bmd-label-floating">Email Frequency</label>
                              <input readonly type="text" class="form-control fctrl" name="frequency" #frequency="ngModel"
                                [(ngModel)]="user.emailFrequency">
                            </div>

                          </div>
                          <div *ngIf="user.role !== 'VENDOR' && user.role !== 'customer' && user.role != 'CUSTOMER'" class="col-md-6">

                            <div class="form-group">
                              <label class="bmd-label-floating">Default Warehouse Location</label>
                              <input  readonly type="text" class="form-control fctrl" name="frequency" #frequency="ngModel"
                                [(ngModel)]="user.location.name">
                            </div>

                          </div>
                          <div *ngIf="user.role !== 'VENDOR' && user.role !== 'customer' && user.role != 'CUSTOMER'" class="col-md-6">

                            <div class="form-group">
<!--                               <label class="bmd-label-floating">Default Department Location</label>
                              <select disabled="yes" readonly name="internalLocation" #internalLocation="ngModel" [(ngModel)]="user.internalLocation.id"
                                class="form-control fctrl">
                                <option *ngFor="let loc of internallocationList" [value]="loc.id">
                                  {{ loc.locationName }}
                                </option>
                              </select> -->
                              <label class="bmd-label-floating">Default Department Location</label>
                              <input  readonly type="text" class="form-control fctrl" name="internalLocation" #internalLocation="ngModel" [(ngModel)]="internallocationname">
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>

                  </form>
                </div>




              </div>
            </div>
          </div>
          <div class="card-body">
            <form>





              <div class="clearfix"></div>
            </form>
          </div>
        </div>







      </div>
      <div class="col-md-4">
        <div class="card card-profile">




          <div class="card-body">
            <h6 class="card-category text-gray">Profile</h6>
            <h4 class="card-title">{{user.name}} {{user.surname}}</h4>
            <p class="card-description">
              <!-- <button *ngIf="user.role != 'customer' && user.role != 'VENDOR'" mat-raised-button class="btn btn-success button-profile" style="width: 90%" (click)="openFormModal()">
                Holy Day Form
              </button> -->
            </p>
          </div>
        </div>


        <div class="card card-profile"
          *ngIf="(user.role == 'VENDOR' || user.role == 'customer') && identity.unbot == 0">




          <div class="card-body">
            <h6 class="card-category text-gray">Purchasing Rep</h6>
            <h4 class="card-title"><i class="material-icons">person</i> {{user.managedByString}}</h4>
            <p class="card-description"></p>
            <h5><i class="material-icons">email</i> {{emailManager}}</h5>
            <h5> <i class="material-icons">phone</i> {{phoneManager}}</h5>


          </div>


        </div>
      </div>
    </div>

    <!-- <div class="row" *ngIf="user.role != 'customer' && user.role != 'VENDOR'">
      <div class="col-md-8">
        <div class="card">

          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">
              Holidays and Absences
            </h4>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12" style="text-align: right;">
                <button class="btn btn-success btn-sm" (click)="openHD()">
                  <i class="material-icons">add</i> ADD HOLIDAY
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div *ngIf="loadingHd" style="text-align: center">
                  <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                </div>
  
                <app-holydays-table *ngIf="!loadingHd" [elements]="holydasy" (out)="boton($event)"></app-holydays-table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->

  </div>
</div>

<div class="modal fade" id="hdModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header" style="text-align:center;">
        <div>
          <h2>
            <b>Holidays</b>
          </h2> <br>
        </div>
      </div>

      <div *ngIf="guardando || cargando" style="text-align:center;" class="modal-body">
        <div *ngIf="cargando">
          <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
        </div>
        <div *ngIf="guardando">
          <h2><b><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i> Saving...</b></h2>
        </div>
      </div>

      <div *ngIf="!guardando && !cargando">

        <div class="modal-body">
          <form #f='ngForm'>
            <div *ngIf="action != 'delete'" class="input-group">

              <div class="row">

                <!-- <div class="col-6">
                  <div class="form-group">
                      <label>Start Date: </label>
                      <input type="date" class="form-control" name="start" #s="ngModel" [(ngModel)]="hdStart" (change)="disponible()" required [disabled]="action == 'read'" matInput>
                  </div>
                </div> -->

                <!-- <div class="col-6">
                  <div class="form-group">
                      <label>End Date: </label>
                      <input type="date" class="form-control" name="end" #end="ngModel" [(ngModel)]="hdEnd" (change)="disponible()" required [disabled]="action == 'read'" matInput>
                  </div>
                </div> -->

              </div>

              <div class="row">
                <!-- <div class="col-12">
                    <div class="form-group">
                        <label class="bmd-label-floating">Notes:</label>
                        <div class="form-group">
                            <textarea name="trakingNotes" #trakingNotes="ngModel" [(ngModel)]="hdComments" class="form-control" rows="3" [disabled]="action == 'read'"></textarea>
                        </div>
                    </div>
                </div> -->
              </div>

              <!-- <div *ngIf="!hdAvailability" class="alert alert-danger" role="alert">
                Date range is not available!
              </div> -->

            </div>

            <div *ngIf="action == 'delete'">
              <h6><b><i class="fa fa-exclamation-triangle" style="color: 'red'" aria-hidden="true"></i>
                  Are you sure you want to delete this Holiday?
                </b></h6>
            </div>

          </form>
        </div>

        <div class="modal-footer" style="text-align:center;">

          <button type="button" class="btn btn-danger btn-lg btn-block" (click)="endHD()">
            {{action == 'read' ? 'Close' : 'Cancel'}}
          </button> &nbsp;&nbsp;
          <button *ngIf="action != 'read'" type="button" class="btn btn-primary btn-lg btn-block" (click)="saveHD()"
            [disabled]="!valid(f)">
            {{action == 'delete' ? 'Continue' : 'Save'}}
          </button>
          <button *ngIf="action == 'read'" type="button" class="btn btn-warning btn-lg btn-block"
            (click)="action = 'update'">
            Edit
          </button>

        </div>

      </div>

    </div>
  </div>
</div>


<div class="modal fade" id="hdFormModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header" style="text-align:center;">
        <div>
          <h2>
            <b>Holidays Form</b>
          </h2> <br>
        </div>
      </div>

      <div class="modal-body">
        <form #hdForm="ngForm">
          <div class="row">

            <div class="col-3">
              <div class="form-group">
                <label>Time Off Start Date: </label>
                <input type="date" class="form-control" name="start" #s="ngModel" (change)="disponible()"
                  [(ngModel)]="holydays.timeOffStartDate" required matInput>
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Time:</label>
                <input type="time" class="form-control" name="startTime" (change)="disponible()"
                  [(ngModel)]="holydays.hrTimeOffStartDate" required />
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Return To Work Date: </label>
                <input type="date" class="form-control" name="end" #end="ngModel" (change)="disponible()"
                  [(ngModel)]="holydays.returnToWorkDate" [disabled]="action == 'read'" required matInput>
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Time:</label>
                <input type="time" class="form-control" name="ebdTime" (change)="disponible()"
                  [(ngModel)]="holydays.hrReturnToWorkDate" required />
              </div>
            </div>

          </div>

          <div class="row"
            *ngIf="holydays.timeOffStartDate > holydays.returnToWorkDate && holydays.returnToWorkDate != ''">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">
                Return To Work Date can’t be before the Time Off Start Date, please select another time
              </div>
            </div>
          </div>

          <div class="row"
            *ngIf="holydays.timeOffStartDate === holydays.returnToWorkDate && holydays.hrTimeOffStartDate > holydays.hrReturnToWorkDate">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">
                Return To Work Date can’t be before the Time Off Start Date, please select another time
              </div>
            </div>
          </div>

          <div class="row" *ngIf="statusHolyday != null">
            <div class="col-12">
              <div class="alert alert-danger" role="alert"
                *ngIf="statusHolyday.status == 'unavailable' && holydays.timeOffStartDate <= holydays.returnToWorkDate">
                Sorry! You cannot authorize free days within the selected date range, you may have pending activities,
                please check your activities or choose a different date range.
              </div>
              <div class="alert alert-success" role="alert"
                *ngIf="statusHolyday.status == 'success' && holydays.timeOffStartDate <= holydays.returnToWorkDate">
                Available! {{statusHolyday.msg}}
              </div>
            </div>
          </div>

          <br>

          <div class="row" style="text-align: center;">
            <div class="col-12">
              <div class="form-group">
                <mat-radio-group name="typeOfLeave" [(ngModel)]="holydays.typeOfLeave" aria-label="Select an option"
                  required>
                  <mat-radio-button value="PTO">PTO (With Pay)</mat-radio-button>
                  &nbsp;&nbsp;
                  <mat-radio-button value="Other">Other Without Pay - describe in <strong>Reason For Leave box</strong>.
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <mat-form-field class="example-full-width has-label">
                  <input type="text" name="reasonforLeave" [(ngModel)]="holydays.reasonforLeave" matInput id="text"
                    placeholder="Reason for Leave" [disabled]="action == 'read'" required>
                </mat-form-field>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-danger" (click)="closeFormModal()">
          Close
        </button>
        &nbsp;&nbsp;
        <button class="btn btn-primary" [disabled]="!validhd(hdForm)" (click)="saveHd()">
          <i *ngIf="savingHd" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i> Save
        </button>
      </div>

    </div>
  </div>
</div>